<template>
    <div>
        <el-container>
            <el-header class="custom-header" height="120px" style="background-color:skyblue;">

                <div class="demo-input-suffix">
                    <el-row :gutter="20" style="margin-top: 10px;">
                        <el-col :span="el_col_span">
                            用户姓名
                            <el-input v-model="form.user_name" readonly :style="this.el_input_width"
                                size="medium"></el-input>
                        </el-col>
                        <el-col :span="el_col_span">
                            用户性别
                            <el-input v-model="form.user_gender_text" readonly :style="el_input_width"
                                size="medium"></el-input>
                        </el-col>
                        <el-col :span="el_col_span">
                            联系方式
                            <el-input v-model="form.user_mobile" readonly :style="el_input_width"
                                size="medium"></el-input>
                        </el-col>
                        <el-col :span="el_col_span">
                            注册时间
                            <el-input v-model="form.create_time" readonly :style="el_input_width"
                                size="medium"></el-input>
                        </el-col>
                    </el-row>
                    <el-row :gutter="20" style="margin-top: 20px;">
                        <el-col :span="el_col_span">
                            用户卡号
                            <el-input v-model="form.user_card.card_number" readonly :style="el_input_width"
                                size="medium"></el-input>
                        </el-col>
                        <el-col :span="el_col_span">
                            卡号类型
                            <el-input v-model="form.user_card.card_type.card_type_name" readonly :style="el_input_width"
                                size="medium"></el-input>
                        </el-col>
                        <el-col :span="el_col_span">

                            卡内余额
                            <el-input v-model="form.user_card.card_balance" readonly :style="el_input_width"
                                size="medium"></el-input>
                        </el-col>
                        <el-col :span="el_col_span">
                            卡有效期
                            <el-input v-model="form.user_card.expiry_date" readonly :style="el_input_width"
                                size="medium"></el-input>
                        </el-col>
                    </el-row>
                </div>
            </el-header>

            <el-main>
                <el-table :data="tableData" style="width: 100%">
                    <el-table-column label="订单ID" prop="order_id">
                    </el-table-column>
                    <el-table-column label="订单时间" prop="service_time">
                    </el-table-column>
                    <el-table-column label="服务类型">
                        <template slot-scope="scope">
                            <el-tag effect="dark" :type="scope.row.service_type_type">
                                {{ scope.row.service_type_text }}
                            </el-tag>
                        </template>
                    </el-table-column>
                    <el-table-column prop="service_name" label="服务名称">
                    </el-table-column>

                    <el-table-column label="交易量（扣卡次数）" prop="trans_record.trans_volume">
                    </el-table-column>

                    <el-table-column prop="trans_record.card_type" label="用户卡类型" width="200px">
                        <!-- <p v-if="trans_record !== null && trans_record.card_type === '体验卡'">
                        <el-tag effect="dark" :type='info'>
                            {{ trans_record.card_type }}
                        </el-tag>
                    </p> -->
                    </el-table-column>

                    <el-table-column prop="order_status_text" label="订单状态">
                        <template slot-scope="scope">
                            <el-tag effect="dark" :type="scope.row.order_status_type">
                                {{ scope.row.order_status_text }}
                            </el-tag>
                        </template>
                    </el-table-column>
                </el-table>
            </el-main>
        </el-container>
    </div>
</template>

<script>
import { getUserDetail } from '@/api/user';
import { SERVICE_TYPE_ENUM, ORDER_STATUS_ENUM, CARD_TYPE_ENUM } from '@/api/constants';


export default {

    data() {
        return {
            tableData: [],
            form: {
                user_name: "",
                user_mobile: "",
                user_card: {
                    card_number: "",
                    card_type: ""
                }
            },
            el_input_width: "width:200px",
            el_col_span: 6
        }
    },
    methods: {
        onSubmit() {
            console.log('submit!');
        },
    },
    created() {
        getUserDetail({ id: this.$route.params.id }).then((res) => {
            if (res.status === 200) {
                this.form = res.data.data

                switch (this.form.user_gender) {
                    case 1: this.form.user_gender_text = "男性"; break;
                    case 0: this.form.user_gender_text = "女性"; break;
                    default: this.form.user_gender_text = "未知"; break;
                }

                this.tableData = res.data.data['orders']
                // console.log(this.tableData)
                this.tableData.forEach(item => {
                    switch (item.service_type) {
                        case SERVICE_TYPE_ENUM.SERVICE_TYPE_FREE.key:
                            item.service_type_text = SERVICE_TYPE_ENUM.SERVICE_TYPE_FREE.value;
                            item.service_type_type = 'success';
                            break;
                        case SERVICE_TYPE_ENUM.SERVICE_TYPE_PAY.key:
                            item.service_type_text = SERVICE_TYPE_ENUM.SERVICE_TYPE_PAY.value;
                            item.service_type_type = 'danger';
                            break;
                        default:
                            item.service_type_text = SERVICE_TYPE_ENUM.SERVICE_TYPE_FEATURED.value;
                            item.service_type_type = 'warning';
                            break;
                    }

                    switch (item.order_status) {
                        case ORDER_STATUS_ENUM.ORDER_STATUS_ORDERED.key:
                            item.order_status_text = ORDER_STATUS_ENUM.ORDER_STATUS_ORDERED.value;
                            item.order_status_type = 'success';
                            break;
                        case ORDER_STATUS_ENUM.ORDER_STATUS_USING.key:
                            item.order_status_text = ORDER_STATUS_ENUM.ORDER_STATUS_USING.value;
                            item.order_status_type = '';
                            break;
                        case ORDER_STATUS_ENUM.ORDER_STATUS_CANCELED.key:
                            item.order_status_text = ORDER_STATUS_ENUM.ORDER_STATUS_CANCELED.value;
                            item.order_status_type = 'info';
                            break;
                        case ORDER_STATUS_ENUM.ORDER_STATUS_COMPLETED.key:
                            item.order_status_text = ORDER_STATUS_ENUM.ORDER_STATUS_COMPLETED.value;
                            item.order_status_type = 'danger';
                            break;
                    }

                    switch (item.trans_record.card_type) {
                        case CARD_TYPE_ENUM.EXPERIENCE_CARD.value:
                            item.trans_record.card_type_type = 'primary';
                            break;
                        case CARD_TYPE_ENUM.VIP_CARD.value:
                            item.trans_record.card_type_type = 'danger';
                            break;
                        case CARD_TYPE_ENUM.VIP_FAMILY_CARD.value:
                            item.trans_record.card_type_type = 'warning';
                            break;
                    }
                    // switch (item.user_role) {
                    //     case USER_ROLE_ENUM.USER_ROLE_LOW.key:
                    //         item.user_role_text = USER_ROLE_ENUM.USER_ROLE_LOW.value;
                    //         item.user_role_type = 'success';
                    //         break;
                    //     case USER_ROLE_ENUM.USER_ROLE_VIP.key:
                    //         item.user_role_text = USER_ROLE_ENUM.USER_ROLE_VIP.value;
                    //         item.user_role_type = '';
                    //         break;
                    //     case USER_ROLE_ENUM.USER_ROLE_REVIEW.key:
                    //         item.user_role_text = USER_ROLE_ENUM.USER_ROLE_REVIEW.value;
                    //         item.user_role_type = 'danger';
                    //         break;
                    // }
                })

            }
        })
    }

}
</script>

<style lang="scss">
.el-form {
    text-align: left;
}

.el-form-item__label {
    font-size: 15px;
    //font-weight: bold;
    align-items: left;

}

.el-input__inner {
    font-size: 12px;
    //font-weight: bold;
}

.el-table th {
    font-size: 18px;
    font-weight: bold;
}

.el-table td {
    font-size: 16px;
    font-weight: bold;

    .el-tag {
        font-size: 16px;
    }
}
</style>